import { useEffect, useState } from "react";

import { isMobileDevice } from "utils";

// Resize-aware wrapper around isMobileDevice so gated views react to viewport changes.
export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() => isMobileDevice());

  useEffect(() => {
    const handleResize = () => setIsMobile(isMobileDevice());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};
